import { StyledTabsList, StyledTab } from './send-tabs.style';

import { tabsOptions } from 'lib/constants';

type TabProps = {
  label: string;
  value: string;
};

const SendTabs = ({
  tab,
  onSelect
}: {
  tab: TabProps;
  onSelect: (item: TabProps) => void;
}) => {
  return (
    <StyledTabsList>
      {tabsOptions.map((item) => (
        <StyledTab
          key={item.value}
          active={tab.value === item.value}
          onClick={() => onSelect(item)}
        >
          {item.label}
        </StyledTab>
      ))}
    </StyledTabsList>
  );
};

export default SendTabs;
